export default [
  {
    path: '/userblog/:userID',
    component: () => import('@/views/pages/blog/user.vue'),
    redirect: '/userblog/:userID/0',
    children: [
      {
        path: 'index',
        name: 'index',
        meta: { title: "学生笔记" },
        component: () => import('@/views/pages/blog/user.vue')
      },
      {
        path: ':blogID',
        name: 'user',
        meta: { title: "学生笔记" },
        component: () => import('@/views/pages/blog/user.vue')
      },
    ]
  },
  {
    path: '/blog',
    component: () => import('@/views/pages/blog/index.vue'),
    redirect: '/blog/create',
    children: [
      {
        path: '/blog/create',
        name: 'create',
        meta: { title: "我的笔记" },
        component: () => import('@/views/pages/blog/index.vue')
      },
      {
        path: ':blogID',
        name: 'userBlog',
        meta: { title: "笔记中心" },
        component: () => import('@/views/pages/blog/index.vue')
      },
    ]
  },
  {
    path: '/courseblog',
    component: () => import('@/views/pages/courseblog/index.vue'),
    redirect: '/courseblog/create',
    children: [
      {
        path: '/courseblog/create',
        name: 'create',
        meta: { title: "我的笔记" },
        component: () => import('@/views/pages/courseblog/index.vue')
      },
      {
        path: ':blogID',
        name: 'userBlog',
        meta: { title: "笔记中心" },
        component: () => import('@/views/pages/courseblog/index.vue')
      },
    ]
  }
]
